import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IOptionItem {
  name: string;
  value: string;
}
interface IStudySwitcherSlice {
  selectedOptionName: string;
  selectedOptionValue: string;
  options: IOptionItem[];
  isConditionSwitcher: boolean;
  /** Bumped only on Study Switcher load / tab change to rebind disclaimer listeners. */
  studySwitcherTrigger: number;
}
export const initialState: IStudySwitcherSlice = {
  selectedOptionName: '',
  selectedOptionValue: '',
  options: [],
  isConditionSwitcher: false,
  studySwitcherTrigger: 0,
};

const studySwitcherSlice = createSlice({
  name: 'studySwitcher',
  initialState,
  reducers: {
    updateOptions: (state, action: PayloadAction<any>) => ({
      ...state,
      options: action.payload,
    }),
    updateSelectedOptionName: (state, action: PayloadAction<any>) => ({
      ...state,
      selectedOptionName: action.payload,
    }),
    updateSelectedOptionValue: (state, action: PayloadAction<any>) => ({
      ...state,
      selectedOptionValue: action.payload,
    }),
    setIsConditionSwitcher: (state, action: PayloadAction<boolean>) => ({
      ...state,
      isConditionSwitcher: action.payload,
    }),
    bumpStudySwitcherTrigger: (state) => ({
      ...state,
      studySwitcherTrigger: state.studySwitcherTrigger + 1,
    }),
  },
});

export const {
  updateOptions,
  updateSelectedOptionName,
  updateSelectedOptionValue,
  setIsConditionSwitcher,
  bumpStudySwitcherTrigger,
} = studySwitcherSlice.actions;
export default studySwitcherSlice.reducer;
